import { TableHeaderItem } from "@/views/components/YtoTable/TableHeaderItem";

const defaultWidth = 120;

const tableHeader: TableHeaderItem[] = [
  { prop: 'index', label: '序号', width: 60, fixed: "left" },
  { prop: 'code', label: '实物条码', width: 300 , fixed: "left"},
  { prop: 'strEmployeeName', label: '收派员', width: 100 },
  { prop: 'strCustomerName', label: '寄件客户', width: 100 },
  { prop: 'strCbxFee', label: '派送时效', width: defaultWidth },
  { prop: 'strDestOrgName', label: '目的地', width: 160 },
  { prop: 'weight', label: '称入重', width: defaultWidth },
  { prop: 'geKouNum', label: '格口号', width: defaultWidth },
  { prop: 'length', label: '长', width: 70 },
  { prop: 'width', label: '宽', width: 70 },
  { prop: 'height', label: '高', width: 70 },
  { prop: 'scanTime', label: '扫描时间', width: 200 },
  { prop: 'state', label: '状态', width: 90 ,fixed: "right"},
  { prop: 'info', label: '提示/警告信息', width: null , fixed: "right"},
];
export default { tableHeader }
